const XAPIKEY = "f4279730-f3f0-463b-bc4a-c1ad8bf10e5d";
// const basePath = "https://ath-apiqa.dvconsulting.org/";
const basePath ="https://insjb-api.dvconsulting.org/";
// const versionPath = "api/v1/";
const baseURL = basePath;
export {
    XAPIKEY,
    baseURL,
    basePath
}